import BaseService from '../base-service';
import { Company } from './company.model';

export default class CompaniesService extends BaseService<Company> {
  get endpoint() {
    return 'companies';
  }
}
